import * as React from 'react';

interface IProps {
  className?: string;
}

/**
 * EMV Calculator View component that loads the calculator in an iframe
 * @type {React.FunctionComponent}
 */
const EMVCalculatorView: React.FunctionComponent<React.PropsWithChildren<IProps>> = React.memo((props) => (
  <div
    className={props.className}
    style={{
      width: '100%',
      height: 'calc(100vh - 140px)',
    }}
  >
    <iframe
      src="https://emv--emv-calculator-a1069.us-central1.hosted.app/"
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
      }}
      title="EMV Calculator"
      allowFullScreen
    />
  </div>
));

export default EMVCalculatorView;
